import React from 'react';
import styles from './InvoiceFormData.module.scss';

const Content = ({ title, text }) => {
  return (
    <span>
      <span className={styles.accent}>{title}</span> {text}
    </span>
  );
};

const InvoiceFormData = ({ sum, typeNames, stateName }) => {
  return (
    <div className={styles.root}>
      <p className={styles.paragraph}>
        <Content
          title="Сумма"
          text={sum || 'Не указана'}
        />

        <Content
          title="Способы оплаты"
          text={typeNames || 'Не указаны'}
        />

        <Content
          title="Статус"
          text={stateName || 'Не указан'}
        />
      </p>
    </div>
  );
};

export default InvoiceFormData;
